module.exports = __webpack_public_path__ + "static/media/firstgoalassister.46438f34.jpg";